import React from "react";
import "./Project.css";
import { greeting, publications } from "../../portfolio.js";

export default function Projects() {
  return (
    <div className="main" id="opensource">
      <h1 className="project-title">My Projects</h1>
      <p className="project-subtitle">
        Check out my open source projects on GitHub
      </p>
      <div className="repo-cards-div-main">
        {publications.data.map((project) => (
          <div
            key={project.id}
            className="repo-card-div"
            onClick={() => window.open(project.url, "_blank")}
          >
            <div className="repo-name-div">
              <svg
                aria-hidden="true"
                height="20"
                role="img"
                viewBox="0 0 16 16"
                width="16"
                className="repo-svg"
              >
                <path
                  fillRule="evenodd"
                  d="M2 2.5A2.5 2.5 0 014.5 0h8.75a.75.75 0 01.75.75v12.5a.75.75 0 01-.75.75h-2.5a.75.75 0 110-1.5h1.75v-2h-8a1 1 0 00-.714 1.7.75.75 0 01-1.072 1.05A2.495 2.495 0 012 11.5v-9zm10.5-1V9h-8c-.356 0-.694.074-1 .208V2.5a1 1 0 011-1h8zM5 12.25v3.25a.25.25 0 00.4.2l1.45-1.087a.25.25 0 01.3 0L8.6 15.7a.25.25 0 00.4-.2v-3.25a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25z"
                ></path>
              </svg>
              <p className="repo-name">{project.name}</p>
            </div>
            <p className="repo-description">{project.description}</p>
            <div className="repo-details">
              <span className="repo-language">
                <span
                  className="language-dot"
                  style={{
                    backgroundColor:
                      project.language === "Dart"
                        ? "#00B4AB"
                        : project.language === "Python"
                        ? "#3572A5"
                        : "#f1e05a",
                  }}
                ></span>
                {project.language || "Dart"}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="project-button-wrapper">
        <a
          className="github-button"
          href={greeting.githubProfile}
          target="_blank"
          rel="noopener noreferrer"
        >
          View All on GitHub
        </a>
      </div>
    </div>
  );
}
